module.exports = __webpack_public_path__ + "media/images/icons/flags/DJ-272562542d271e74cc6028d76bbfd540.svg";